/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaAttributoEsercenteDTO } from '../model/models';
import { TipoPraticaAttributoEsercenteCreationForm } from '../model/models';
import { TipoPraticaAttributoEsercenteDTO } from '../model/models';
import { TipoPraticaAttributoEsercenteListFilter } from '../model/models';
import { TipoPraticaAttributoEsercentePatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaAttributoEsercenteRequestParams {
    idTipoPratica: string;
    tipoPraticaAttributoEsercenteCreationForm: TipoPraticaAttributoEsercenteCreationForm;
}

export interface DeleteTipoPraticaAttributoEsercenteRequestParams {
    idTipoPratica: string;
    idAttr: string;
}

export interface GetTipoPraticaAttributoEsercenteRequestParams {
    idTipoPratica: string;
    idAttr: string;
}

export interface ListTipoPraticaAttributiEsercenteRequestParams {
    idTipoPratica: string;
    filter: TipoPraticaAttributoEsercenteListFilter;
    pageable: Pageable;
}

export interface UpdateTipoPraticaAttributoEsercenteRequestParams {
    idTipoPratica: string;
    idAttr: string;
    tipoPraticaAttributoEsercentePatchForm: TipoPraticaAttributoEsercentePatchForm;
}


export interface TipoPraticaAttributoEsercenteControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo attributo del form esercente (3 assi: binding/ui_widget/validation)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente
* @param requestParameters
     */
    createTipoPraticaAttributoEsercente(requestParameters: CreateTipoPraticaAttributoEsercenteRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteDTO>;

    /**
     * Elimina un attributo esercente (cascade ai valori catalogati)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}
* @param requestParameters
     */
    deleteTipoPraticaAttributoEsercente(requestParameters: DeleteTipoPraticaAttributoEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un attributo esercente per id (include \&#39;valori\&#39; inline per CUSTOM_SINGLE_CHOICE/CUSTOM_MULTIPLE_CHOICE)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}
* @param requestParameters
     */
    getTipoPraticaAttributoEsercente(requestParameters: GetTipoPraticaAttributoEsercenteRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteDTO>;

    /**
     * Lista paginata degli attributi esercente del TipoPratica (filtri: binding, ui_widget, obbligatorio, q)
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente
* @param requestParameters
     */
    listTipoPraticaAttributiEsercente(requestParameters: ListTipoPraticaAttributiEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaAttributoEsercenteDTO>;

    /**
     * Replace di un attributo esercente (richiede version; chiave/binding frozen post-pubblicazione)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/attributi-esercente/{idAttr}
* @param requestParameters
     */
    updateTipoPraticaAttributoEsercente(requestParameters: UpdateTipoPraticaAttributoEsercenteRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaAttributoEsercenteDTO>;

}
